import {POST} from "../../../Hooks/RequestV2";

export default function processingUserData(data: any, deps: {
    user: any;
    userLoginData: any;
    setNotification: (value: any) => void;
}){
    let saleDepartment: any;
    const {user, userLoginData, setNotification} = deps;

    user?.salesDepartmentInfo.map((sd: any) => {
        if (sd.hostName === data.saleDepartment){
            saleDepartment = sd;
        }
    });

    if (!data.contractor){
        data.contractor = user?.receiver.contractor.id;
    }

    POST('/check-currency-problem', {contractor_id: data.contractor, sale_department_id: saleDepartment.id})
        .then((response) => {
            if (response.status === 204){

                POST('/user/login_auth', userLoginData)
                    .then(() => {
                        setNotification(null);

                        if (data.hasOwnProperty('contractor')){
                            localStorage.setItem('contractor', data.contractor);
                        } else {
                            localStorage.removeItem('contractor');
                        }

                        POST('/user/report', {
                            sale_department_id: saleDepartment.id,
                            contractor_id: data.contractor,
                            shop_user_id: user?.id
                        })
                            .then((response) => {
                                if (response.ok){
                                    if (data.saleDepartment === window.location.hostname){
                                        window.location.href = '/?mini-cart=true&contractor='+data.contractor;
                                        return;
                                    }

                                    window.location.href = 'https://'+data.saleDepartment+'?mini-cart=true&contractor='+data.contractor;
                                }
                            })


                    });
            } else {
                setNotification('Z uwagi na podpięcie cennika walutowego nie możesz się zalogować. Skontaktuj się ze swoim opiekunem lub z administratorem.');
            }
        });
}